<template>
  <ContentWrap>
    <el-alert type="info" :closable="false" show-icon class="mb-12px" title="所内公告：草稿 → 发布 / 下架。本所 firm_id 隔离（与 Admin 代管同源服务）。" />
    <el-form :inline="true" class="mb-12px">
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable class="!w-120px">
          <el-option label="草稿" value="DRAFT" />
          <el-option label="已发布" value="PUBLISHED" />
          <el-option label="已下架" value="ARCHIVED" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">搜索</el-button>
        <el-button type="success" @click="openCreate">新建公告</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="list" border>
      <el-table-column prop="id" label="编号" width="70" />
      <el-table-column prop="title" label="标题" min-width="160" show-overflow-tooltip />
      <el-table-column prop="scopeType" label="范围" width="90" />
      <el-table-column prop="status" label="状态" width="100" />
      <el-table-column prop="publishTime" label="发布时间" width="170" />
      <el-table-column label="操作" width="140" fixed="right">
        <template #default="{ row }">
          <el-button v-if="row.status === 'DRAFT'" link type="primary" @click="doPublish(row)">发布</el-button>
          <el-button v-if="row.status === 'PUBLISHED'" link type="warning" @click="doArchive(row)">下架</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination v-model:page="query.pageNo" v-model:limit="query.pageSize" :total="total" @pagination="getList" />
    <Dialog v-model="visible" title="新建公告" width="560px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="标题" prop="title"><el-input v-model="form.title" maxlength="128" /></el-form-item>
        <el-form-item label="范围" prop="scopeType">
          <el-select v-model="form.scopeType" class="!w-100%">
            <el-option label="全所 FIRM" value="FIRM" />
            <el-option label="组织 ORG" value="ORG" />
          </el-select>
        </el-form-item>
        <el-form-item label="正文" prop="content"><el-input v-model="form.content" type="textarea" :rows="5" /></el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存草稿</el-button>
      </template>
    </Dialog>
  </ContentWrap>
</template>
<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import { FirmOfficeApi, type PracticeNoticeVO } from '@/api/firm/office'
defineOptions({ name: 'FirmPracticeNotice' })
const message = useMessage()
const loading = ref(false)
const list = ref<PracticeNoticeVO[]>([])
const total = ref(0)
const query = reactive({ pageNo: 1, pageSize: 10, status: undefined as string | undefined })
const visible = ref(false)
const saving = ref(false)
const formRef = ref<FormInstance>()
const form = reactive({ title: '', content: '', scopeType: 'FIRM' })
const rules: FormRules = {
  title: [{ required: true, message: '必填', trigger: 'blur' }],
  content: [{ required: true, message: '必填', trigger: 'blur' }],
  scopeType: [{ required: true, message: '必选', trigger: 'change' }]
}
const getList = async () => {
  loading.value = true
  try {
    const data = await FirmOfficeApi.noticePage(query)
    list.value = data?.list || []
    total.value = data?.total || 0
  } finally {
    loading.value = false
  }
}
const handleQuery = () => { query.pageNo = 1; getList() }
const openCreate = () => {
  Object.assign(form, { title: '', content: '', scopeType: 'FIRM' })
  visible.value = true
}
const submit = async () => {
  await formRef.value?.validate()
  saving.value = true
  try {
    await FirmOfficeApi.noticeCreate({ title: form.title.trim(), content: form.content.trim(), scopeType: form.scopeType })
    message.success('已创建')
    visible.value = false
    await getList()
  } finally {
    saving.value = false
  }
}
const doPublish = async (row: PracticeNoticeVO) => {
  if (!row.id) return
  await FirmOfficeApi.noticePublish(row.id)
  message.success('已发布')
  await getList()
}
const doArchive = async (row: PracticeNoticeVO) => {
  if (!row.id) return
  await FirmOfficeApi.noticeArchive(row.id)
  message.success('已下架')
  await getList()
}
onMounted(getList)
</script>
